import type { AssignableRole, HrRoleOption, Role } from './types';

export const DEFAULT_HR_ROLE_OPTIONS: HrRoleOption[] = [
  { value: 'STAFF', label: '员工' },
  { value: 'MANAGER', label: '主管' },
  { value: 'ADMIN', label: '管理员' },
];

const ASSIGNABLE_ROLE_SET = new Set<AssignableRole>(
  DEFAULT_HR_ROLE_OPTIONS.map((role) => role.value),
);

export function normalizeHrRoleOptions(roles: HrRoleOption[] | undefined): HrRoleOption[] {
  const labels = new Map<AssignableRole, string>();
  for (const role of roles ?? []) {
    if (!ASSIGNABLE_ROLE_SET.has(role.value)) continue;
    const label = role.label.trim();
    if (label.length === 0 || label.length > 32) continue;
    labels.set(role.value, label);
  }
  return DEFAULT_HR_ROLE_OPTIONS.map((role) => ({
    value: role.value,
    label: labels.get(role.value) ?? role.label,
  }));
}

export function hrRoleLabel(role: Role, roles: HrRoleOption[] | undefined): string {
  if (role === 'SUPER_ADMIN') return '超级管理员';
  return normalizeHrRoleOptions(roles).find((item) => item.value === role)?.label ?? role;
}

export function withCurrentPosition(
  positions: string[] | undefined,
  current: string | null | undefined,
): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const push = (value: string | null | undefined) => {
    const name = (value ?? '').trim();
    if (!name || seen.has(name)) return;
    seen.add(name);
    out.push(name);
  };
  push(current);
  for (const position of positions ?? []) push(position);
  return out;
}
